module.exports = __webpack_public_path__ + "img/ordenarDiente.98418306.svg";